import styled from "@emotion/styled";
import Image from "next/image";

import p1 from "../../assets/images/partners/p1.png";
import p2 from "../../assets/images/partners/p2.png";
import p3 from "../../assets/images/partners/p3.png";
import p4 from "../../assets/images/partners/p4.png";
import p5 from "../../assets/images/partners/p5.png";
import p6 from "../../assets/images/partners/p6.png";
import p7 from "../../assets/images/partners/p7.png";
import p8 from "../../assets/images/partners/p8.png";
import p9 from "../../assets/images/partners/p9.png";
import p10 from "../../assets/images/partners/p10.png";
import p11 from "../../assets/images/partners/p11.png";
import p12 from "../../assets/images/partners/p12.png";
import p13 from "../../assets/images/partners/p13.png";
import p14 from "../../assets/images/partners/p14.png";
import p15 from "../../assets/images/partners/p15.png";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 25px;
  margin-top: 50px;
`;

const ImgWRapper = styled.div`
  position: relative;
  height: 100px;
  width: 100px;
`;

const images = [
  p4,
  p12,
  p7,
  p15,
  p14,
  p1,
  p2,
  p3,
  p5,
  p6,
  p8,
  p9,
  p10,
  p11,
  p13,
];

const Partners = () => {
  return (
    <Wrapper>
      {images.map((img, i) => (
        <ImgWRapper key={`key-${i}`}>
          <Image alt="partner-img" src={img} fill />
        </ImgWRapper>
      ))}
    </Wrapper>
  );
};

export default Partners;
